import { HttpClientJsonpModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { StoreModule } from '@ngrx/store';
import { rootReducer } from './state/fund-chart-creator.reducer';
import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';
import { ConfigModule } from 'Angular/config/config.module';
import { SimpleDropdownModule } from 'Angular/features/components/dropdowns/simple-dropdown/simple-dropdown.module';
import { SingleSelectDropdownModule } from 'Angular/features/components/dropdowns/single-select-dropdown/single-select-dropdown.module';
import { RadioButtonGroupModule } from 'Angular/features/components/inputs/radio-button-group/radio-button-group.module';
import { SimpleInputModule } from 'Angular/features/components/inputs/simple-input/simple-input.module';
import { ModalBaseModule } from 'Angular/features/components/modals/modal-base/modal-base.module';
import { NavigationModule } from 'Angular/features/components/navigation/navigation.module';
import { DisabledModule } from 'Angular/features/directives/disabled/disabled.module';
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import { ChartsSharedModule } from 'ChartApp/ts/features/charts-shared/charts-shared.module';
import { FundChartPageSharedModule } from 'ChartApp/ts/features/fund-chart-page-shared/fund-chart-page-shared.module';
import { FundChartCreatorPageComponent } from './components/fund-chart-creator-page/fund-chart-creator-page.component';
import { TopBarNavComponent } from 'Angular/features/components/navigation/top-bar-nav/top-bar-nav.component';
import { getLogger } from 'Angular/state/logger';
import { StoreDevtoolsModule } from 'Angular/state/store-devtools/store-devtools.development';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "@ngrx/store";
import * as i3 from "@ngrx/store-devtools";
export class FeatureServiceAllowAll extends FeatureService {
    constructor() {
        super(...arguments);
        this.allFeaturesAvailable = true;
    }
}
FeatureServiceAllowAll.ɵfac = /*@__PURE__*/ (() => { let ɵFeatureServiceAllowAll_BaseFactory; return function FeatureServiceAllowAll_Factory(__ngFactoryType__) { return (ɵFeatureServiceAllowAll_BaseFactory || (ɵFeatureServiceAllowAll_BaseFactory = i0.ɵɵgetInheritedFactory(FeatureServiceAllowAll)))(__ngFactoryType__ || FeatureServiceAllowAll); }; })();
FeatureServiceAllowAll.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: FeatureServiceAllowAll, factory: FeatureServiceAllowAll.ɵfac });
export class FundChartCreatorModule {
}
FundChartCreatorModule.ɵfac = function FundChartCreatorModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FundChartCreatorModule)(); };
FundChartCreatorModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: FundChartCreatorModule, bootstrap: [FundChartCreatorPageComponent, TopBarNavComponent] });
FundChartCreatorModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [{ provide: FeatureService, useClass: FeatureServiceAllowAll }], imports: [BrowserModule,
        ChartsSharedModule,
        // Jsonp module must be imported before ConfigModule to
        // prevent X-CSRFToken header from being included in
        // jsonp requests https://github.com/angular/angular/issues/47312
        HttpClientJsonpModule,
        ConfigModule,
        DisabledModule,
        FormsModule,
        FundChartPageSharedModule,
        IconModule,
        ModalBaseModule,
        NavigationModule,
        RadioButtonGroupModule,
        RouterModule.forRoot([], { useHash: true }),
        SimpleDropdownModule,
        SimpleInputModule,
        SingleSelectDropdownModule,
        StoreModule.forRoot({ reducers: rootReducer }, { metaReducers: getLogger() }),
        StoreDevtoolsModule] });
